export default [
  {
    name: 'BERNIER',
  },
  {
    name: 'Cervo',
  },
  {
    name: 'Rubik',
  },
  {
    name: 'Sensei',
  },
  {
    name: 'OpenSans',
  },
  {
    name: 'Hagin',
  },
  {
    name: 'NotoSerif',
  },
  {
    name: 'RobotoSlab',
  },
  {
    name: 'ProximaNova',
  },
  // TODO: uncomment when ready to use in adi site and render in font picker
  //  https://jira.wixpress.com/browse/VMAF-255
  // {
  //   name: 'CourierNew',
  // },
  // {
  //   name: 'Georgia',
  // },
  // {
  //   name: 'Raleway',
  // },
  // {
  //   name: 'FuturaPT',
  // },
  // {
  //   name: 'Intro',
  // },
  // {
  //   name: 'Philosopher',
  // },
];
